import { Injectable, Injector } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppEnum } from 'src/app/appenum';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  secretKey = 'DigitalEyesFBAllianceins';
  componentName: any = 'encryption-service';

  constructor(public _appenum: AppEnum,
    private injector: Injector
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }

  hashValueConversion(value: any) {
    var hash = CryptoJS.MD5(value);
    return hash;
  }

  localstorageEncrypt(key: string, value: any) {
    const combinedKey = key + '_' + sessionStorage.getItem('tabId')
    // var encryptedKey = this.encrypt(key);
    var encryptedKey = combinedKey;
    var encryptedValue = this.encrypt(value);
    return localStorage.setItem(encryptedKey, encryptedValue);
  }

  localstorageDecrypt(key: string) {
    // var encryptedKey = this.encrypt(key);
    const combinedKey = key + '_' + sessionStorage.getItem('tabId')
    var encryptedKey = combinedKey;
    return localStorage.getItem(encryptedKey);
  }

  sessionstorageEncrypt(key: string, value: any) {
    var encryptedKey = this.encrypt(key);
    var encryptedValue = this.encrypt(value);
    return sessionStorage.setItem(encryptedKey, encryptedValue);
  }

  sessionstorageDecrypt(key: string) {
    var encryptedKey = this.encrypt(key);
    return sessionStorage.getItem(encryptedKey);
  }

  encrypt(value: string) {
    value = !value ? '' : value;
    var key = CryptoJS.enc.Utf8.parse(this.secretKey);
    var iv = CryptoJS.enc.Utf8.parse(this.secretKey);
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return encrypted.toString();
  }

  decrypt(value) {
    value = !value ? '' : value;
    var key = CryptoJS.enc.Utf8.parse(this.secretKey);
    var iv = CryptoJS.enc.Utf8.parse(this.secretKey);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
